module.exports = __webpack_public_path__ + "img/461-bacf08.png";